module.exports = __webpack_public_path__ + "static/media/ambassadors_office.072d6345.png";